import React, { } from "react";
import RenderComponent from "../../../General/RenderComponent";
import LineChart from "../../../Charts/LineChart";

function WhiteSpaceLineChart({
    data,
    noData
}) {
    return (

        <div style={{ width: "100%", height: "100%" }} className="d-flex-col">
            <RenderComponent show={noData} isFullscreen>
                <LineChart
                    data={data}
                    chartProps={{
                        xField: "name",
                        yField: "score",
                        seriesField: "brand",
                        legend: {
                            layout: "horizontal",
                            position: "top",
                            flipPage: false,
                            maxRow: 5,
                            itemName: {
                                style: {
                                    fontSize: 13,
                                    fontWeight: "bold"
                                }
                            }
                        },
                        tooltip: {
                            formatter: (datum) => ({ name: datum.brand, value: `${(datum.score).toFixed(2)}%` })
                        },
                        point: {
                            shape: () => "circle"
                        },
                        smooth: true,
                        yAxis: {
                            label: {
                                formatter: (val) => `${val}%`
                            }
                        },
                        xAxis: {
                            label: {
                                formatter: (val) => val.replace(/ /g, "\n"),
                                style: {
                                    fill: "black"
                                }
                            }
                        },
                        theme: {
                            colors10: [
                                "#2473BD",
                                "#DA0000",
                                "#F8C400",
                                "#820DAF",
                                "#57AD57",
                                "#777777",
                                "#F87900",
                                "#D91955",
                                "#1E96BE",
                                "#7DC240"
                            ],
                            colors20: [
                                "#2473BD",
                                "#DA0000",
                                "#F8C400",
                                "#820DAF",
                                "#57AD57",
                                "#777777",
                                "#F87900",
                                "#D91955",
                                "#1E96BE",
                                "#7DC240",
                                "#482BBD",
                                "#E7531F",
                                "#17B8BE",
                                "#986232",
                                "#C3D039",
                                "#37B38B",
                                "#F8A200",
                                "#F8E700",
                                "#6366F1",
                                "#776E57"
                            ]
                        }
                    }}
                />
            </RenderComponent>
        </div>
    );
}

export default WhiteSpaceLineChart;
